import { Currency } from "@redotech/money/currencies";
import { zCurrency } from "@redotech/money/usd-amounts";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum PaymentSchedule {
  PREPAID = "prepay",
  POSTPAID = "postpay",
}

export enum AlertStatus {
  ALERTED = "alerted",
  UNALERTED = "unalerted",
}

export const BaseBalanceSchema = z.object({
  amount: z.string().meta({ privacy: privacy.nonPii }),
  currency: zCurrency.meta({ privacy: privacy.nonPii }).default(Currency.USD),
  paymentSchedule: createEnum(PaymentSchedule, {
    enumName: "PaymentSchedule",
  }).meta({ privacy: privacy.nonPii }),
  alertThreshold: z.string().meta({ privacy: privacy.nonPii }),
  alertStatus: createEnum(AlertStatus, { enumName: "AlertStatus" }).meta({
    privacy: privacy.nonPii,
  }),
});

// Map settings types to a Mongoose model and a Typescript interface
export const balanceSchemas = { "outbound-labels": BaseBalanceSchema };

export enum BalanceTypes {
  OUTBOUND_LABELS = "outbound-labels",
}

const BalanceSchemaBaseDocument = z.object({
  _id: zExt.objectId().meta({ privacy: privacy.nonPii }),
  team: zExt.objectId().meta({ privacy: privacy.nonPii }),
  createdAt: z.date().meta({ privacy: privacy.nonPii }),
  updatedAt: z.date().meta({ privacy: privacy.nonPii }),
  kind: createEnum(BalanceTypes, { enumName: "BalanceTypes" }).meta({
    privacy: privacy.nonPii,
  }),
});

const OutboundLabelsBalanceDocument = BalanceSchemaBaseDocument.extend({
  kind: z
    .literal(BalanceTypes.OUTBOUND_LABELS)
    .meta({ privacy: privacy.nonPii }),
  balance: balanceSchemas["outbound-labels"].meta({
    privacy: privacy.structured,
  }),
});

export const BalanceSchemaDocument = z.discriminatedUnion("kind", [
  OutboundLabelsBalanceDocument,
]);

export type balanceTypes = {
  [key in keyof typeof balanceSchemas]: z.infer<(typeof balanceSchemas)[key]>;
};
